var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('sectionHeading',{attrs:{"text":"New Arrivals"}}),_c('div',{staticClass:"productContainer"},_vm._l((_vm.productData),function(product){return _c('productCard',{key:product.id,attrs:{"product":product}})}),1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }